/* Node modules */
import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

/* Components */
import Header from './Header';

import {
	toggleAuthenticateModal,
	logoutRequest
} from '../authenticate/authenticateActions';
import { logout } from '../webAPI/userService';
import { login } from '../webAPI/userService';
import { unsetInterlocutor } from '../webAPI/employeeService';
import { getIsAuthenticated, doClearUser } from '../reducers/user';
import { doShowDialog } from '../reducers/app/dialog';

import { browserHistory } from 'react-router';

// import { getIsSaving } from "../matrix/matrixReducer";

// const HeaderContainer = (props) => {
// 	return (
// 			<Header
// 				user={props.user}
// 				onGoToMyProjectsClick={props.handleGoToMyProjectsClick}
// 			/>
// 	);
// };

const mapStateToProps = (state, ownProps) => {
	const routeIndex = ownProps.routes[ownProps.routes.length - 1].index;
	return {
		user: state.user,
		isAuthenticated: getIsAuthenticated(state),
		// isSaving: getIsSaving(state),
		routeIndex
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	const { projectId } = ownProps.params;

	const logoutService = __COM__ ? unsetInterlocutor : logout;

	return {
		logout: () => {
			// TODO: display confirmation dialog
			//dispatch(doShowDialog('CONFIRMATION_DIALOG'));
			logoutService().then(
				error => null,
				result => {
					dispatch(doClearUser());
					browserHistory.push('/');
				}
			);
		},

		goToMyProjectsClick: () => {
			browserHistory.push('/app/project-v2');
		},
		toggleAuthenticateModal: () => {
			dispatch(toggleAuthenticateModal());
		},
		login: () => {
			const redirection = projectId
				? `/login/${encodeURIComponent(projectId)}`
				: '/login';

			browserHistory.push(redirection);
		}
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./src/js/app/HeaderContainer.js